import { Chip } from "@mui/material";
import { ReactElement } from "react";

export function statusChip(status: number): ReactElement {
    switch (Number(status)) {
        case 1:
            return <Chip label="Em Aberto" size="small" />;
        case 2:
            return <Chip label="Fechada" size="small" color="primary" />;
        case 3:
            return <Chip label="Atrasada" size="small" color="warning" />;
        case 4:
            return <Chip label="Recebido" size="small" color="success" />;
        case 5:
            return (
                <Chip label="Sem Pendências" size="small" color="secondary" />
            );
        case 6:
            return <Chip label="Cancelada" size="small" color="error" />;
        case 7:
            return <Chip label="Inativo" size="small" />;
        case 8:
            return <Chip label="Processando" size="small" color="info" />;
        default:
            return <Chip label="desconhecido" size="small" />;
    }
}
